import { createPortal } from 'react-dom';
import { useLoader } from '../../../../context/useLoader';
import styles from './index.module.scss';

const Loader = () => {
  const { isVisible } = useLoader();

  if (!isVisible) return null;

  return createPortal(
    <div className={styles.loaderOverlay}>
      <div className={styles.ldsEllipsis}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className={styles.loaderBackground}></div>
    </div>,
    document.body
  );
};

export default Loader;